import { serverHost } from "../../config";

const BASE_URL = serverHost;

export const GET_CLIENT_BY_TIN_URL = BASE_URL + "/imzo/get-user-by-tin";
export const GET_CLIENT_BY_PASSPORT_URL =
  BASE_URL + "/imzo/get-user-by-passport";
export const AUTH_VERIFICATION_URL = BASE_URL + "/auth/me";
export const GET_IMAGE_URL = BASE_URL + "/image";
export const GET_PASSPORT_DATA_URL =
  BASE_URL + "/identification/get-data-from-passport";

export const CHECK_LIVENESS_URL = BASE_URL + "/identification/check-liveness";
export const COMPARE_FACE_URL = BASE_URL + "/identification/compare-face";

export const SET_RESULT_URL = BASE_URL + "/result/set-user-result";
export const IMZO_UPDATE_USER_URL = BASE_URL + "/imzo/update-user/";

export const LOGIN_URL = BASE_URL + "/auth/login-others";
export const REGISTER_URL = BASE_URL + "/auth/register";

export const GET_ALL_USERS = BASE_URL + "/user/all";
export const CREATE_USER = BASE_URL + "/user";

export const GET_ALL_ORGANIZATIONS = BASE_URL + "/organization/all";
export const CREATE_ORGANIZATION = BASE_URL + "/organization";

export const SEND_OTP_CODE_URL = BASE_URL + "/sms/verification-phone-number";
export const VERIFY_OTP_CODE_URL = BASE_URL + "/sms/verification-code";
